import type { UIPosition } from '@hotjar/webapp/domains/highlights/api';
import { ShortLinkDropdown } from './ShortLinkDropdown';
import { useGetShortlink } from '../Highlights/List/use-get-shortlink';

interface StandaloneShortLinkDropdownProps {
  title?: string;
  uiPosition?: UIPosition;
  highlightId?: string | null;
}

export function StandaloneShortLinkDropdown({
  title,
  uiPosition,
  highlightId,
}: StandaloneShortLinkDropdownProps): JSX.Element {
  const { selectAndCopy, outputRef, shortUrl } = useGetShortlink(highlightId ?? null, uiPosition);

  return (
    <ShortLinkDropdown title={title} onCopy={selectAndCopy} ref={outputRef} shortUrl={shortUrl} />
  );
}
